//
//
//
//
//
//

export default {
  props: {
    isWidthMobileFull: {
      type: Boolean,
      default: false,
    },
  },
}
